import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { InventoryReminderDto, SettingsInventoryDTO } from "../models/settings";
import { store } from "./store";

export default class InventorySettingsStore {
    constructor() {
        makeAutoObservable(this);
    }

    loadingInitial = false;
    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    };

    private _inventorySettings: SettingsInventoryDTO | undefined;
    private loadingPromise: Promise<any> | null = null;
    private loadingComplete = false;

    inventoryReminderRegistry = new Map<string, InventoryReminderDto>();
    hideInventoryReminders: boolean = false;
    

    loadInventorySettings = async () => {
        this.loadingInitial = true;
        try {
            const result = await agent.inventorySettings.getInventorySettings();
            runInAction(() => {
                this._inventorySettings = result;
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.setLoadingInitial(false);
        }
    };

    loadInventoryReminders = async () => {
        this.loadingInitial = true;
        try {
            const result = await agent.inventorySettings.getInventoryReminders();
            runInAction(() => {
                result.forEach((invRem: InventoryReminderDto) => this.setInventoryReminder(invRem))
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.loadingInitial = false;
        }
    };


    addInventorySettings = async (values: SettingsInventoryDTO) => {
        this.loadingInitial = true;
        try {
            await agent.inventorySettings.addInventorySettings(values);
        } catch (error) {
            console.log('error:', error);
        } finally {
            runInAction(() => {
                this.loadingInitial = false;
            });
        }
    }

    updateInventorySettings = async (values: SettingsInventoryDTO) => {
        this.loadingInitial = true;
        try {
            await agent.inventorySettings.updateInventorySettings(values);
        } catch (error) {
            console.log('error:', error);
        } finally {
            runInAction(() => {
                this.loadingInitial = false;
            });
        }
    }

    setInventoryReminder = (inventoryReminder: InventoryReminderDto) => {
        this.inventoryReminderRegistry.set(inventoryReminder.id, inventoryReminder);
    }

    get getInventoryReminders() {
        return Array.from(this.inventoryReminderRegistry.values())
                    .sort((a, b) => a.currentQuantity - b.currentQuantity);
    }

    cancelInventoryReminders = () => {
        this.hideInventoryReminders = true;
    }

    get inventorySettings() {
        if (!store.userStore.isLoggedIn) {
            return null;
        }

        if (!this.loadingComplete) {
            this.fetchData();
        }
        return this._inventorySettings;
    }

    fetchData = async () => {
        if (!this.loadingPromise) {
            this.loadingPromise = this.loadInventorySettings()
                .then(r => {
                    this.loadingPromise = null;
                    this.loadingComplete = true;
                })
                .catch(e => {
                    this.loadingPromise = null;
                    throw e;
                })
        }
    }
}
